export function duration(ms) {
  if (ms == null) return "–";
  const m = Math.round(ms / 60000);
  if (m < 60) return `${m} min.`;
  if (m < 60 * 48) return `${Math.floor(m / 60)} t.${m % 60 ? ` ${m % 60} min.` : ""}`;
  return `${Math.round(m / 1440)} dage`;
}

export const rateCls = (r) => (r >= 80 ? "good" : r >= 60 ? "ok" : "low");
